import { AccordionDetails, AccordionDetailsProps, styled } from '@mui/material';
import { ReactElement } from 'react';

import { PoolAccordionVariant, useAccordionContext } from './pool-accordion';

interface StyledAccordionDetailsProps extends AccordionDetailsProps {
    variant?: PoolAccordionVariant;
}

const StyledAccordionDetails = styled(AccordionDetails, {
    shouldForwardProp: prop => prop !== 'variant',
})<StyledAccordionDetailsProps>(({ theme, variant }) => ({
    ...theme.typography.body1,

    ...(variant === 'small' && {
        ...theme.typography.body2,
        color: theme.palette.grey['800'],
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(2),
    }),
}));

export const PoolAccordionDetails = (props: AccordionDetailsProps): ReactElement => {
    const { variant } = useAccordionContext();

    return <StyledAccordionDetails variant={variant} {...props} />;
};
